import axios from "axios";
import { DonationURL } from "../../../config/UrlEndPoint";

export const URL = `${DonationURL}thk_area`;

// Get Area All For use Combobox data
export function getAreaAll() {
  return axios.get(URL);
}

export function searchArea(queryString) {
    return axios.get(`${URL}/search?${queryString}`);
}

//Get By ID
export function getAreaById(areaId) {
  return axios.get(`${URL}/${areaId}`);
}

// items => filtered/sorted result for table data
export function findArea(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the area on the server
export function createArea(area) {
  return axios.post(URL, area);
}

// UPDATE => PUT: update the area on the server
export function updateArea(area) {
  return axios.put(`${URL}/${area.uuid}`, area);
}

// UPDATE => Delete: Delete the area on the server
export function deleteArea(uuid) {
  return axios.delete(`${URL}/${uuid}`);
}
